// extracted by mini-css-extract-plugin
module.exports = {"footer":"PrivateLayoutFooter_footer__sUhBh","footer_content":"PrivateLayoutFooter_footer_content__2Jrxb"};